"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageComposer = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const lodash_1 = __importDefault(require("lodash"));
const react_redux_1 = require("react-redux");
const urlRegex_1 = require("../../../helper/urlRegex");
const LinkPreview_1 = require("../message/LinkPreview");
const RemoveCircle_1 = require("../../../sharedComponents/RemoveCircle");
const store_1 = require("../../store");
const mailboxActions_1 = require("../../store/mailboxActions");
const helpers_1 = require("../../helpers");
const theme_1 = require("../../../theme");
const Avatar_1 = require("../../../sharedComponents/Avatar");
const ImagePreview_1 = require("./ImagePreview");
const TextInput_1 = require("./TextInput");
const MessageComposerReducer_1 = require("./MessageComposerReducer");
const checkForLink = lodash_1.default.debounce((text, setDetectedLink) => {
    const match = text.match(urlRegex_1.REGEXP_URL);
    if (match) {
        setDetectedLink(match[0]);
    }
    else {
        setDetectedLink(undefined);
    }
}, 1000, { leading: false, trailing: true });
const MessageComposer = ({ cameraIcon, EmojiSelector, ImageUploadButton, linkPreviewAPIUrl, messengerDisabled, placeholder, removeIcon, sendIcon, sendMessage: sendMessageToApi, }) => {
    var _a;
    const dispatch = react_redux_1.useDispatch();
    const currentConversationId = store_1.useCurrentConversationId();
    const me = store_1.useConversationPartner(true);
    const [state, localDispatch] = react_1.useReducer(MessageComposerReducer_1.messageComposerLocalReducer, {});
    const { text, images, detectedLink, linkPreview } = currentConversationId
        ? (_a = state[currentConversationId]) !== null && _a !== void 0 ? _a : MessageComposerReducer_1.initialStateEntry : MessageComposerReducer_1.initialStateEntry;
    const theme = theme_1.useSharedTheme();
    const sendMessage = react_1.useCallback(() => {
        if (!currentConversationId)
            return;
        const trimmedText = text.trim();
        const body = trimmedText.length > 0 ? trimmedText : undefined;
        // Errors are (should be) handled and logged in the api of the client already
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        sendMessageToApi(currentConversationId, body, linkPreview === null || linkPreview === void 0 ? void 0 : linkPreview.originalUrl, images).then((message) => {
            localDispatch({ currentConversationId, type: 'reset' });
            if (message)
                dispatch(mailboxActions_1.addMessage({ message }));
        });
    }, [
        currentConversationId,
        dispatch,
        images,
        linkPreview,
        sendMessageToApi,
        text,
    ]);
    const addImages = react_1.useCallback((newImages) => {
        localDispatch({
            currentConversationId,
            images: images.concat(newImages),
            type: 'setImages',
        });
    }, [currentConversationId, images]);
    const onSelectEmoji = react_1.useCallback((selectedEmoji) => {
        localDispatch({
            currentConversationId,
            emoji: selectedEmoji,
            type: 'addEmoji',
        });
    }, [currentConversationId]);
    const onChangeText = react_1.useCallback((newText) => localDispatch({
        currentConversationId,
        text: newText,
        type: 'setText',
    }), [currentConversationId]);
    const onSelectionChange = react_1.useCallback((start, end) => localDispatch({
        currentConversationId,
        selection: { end, start },
        type: 'setSelection',
    }), [currentConversationId]);
    // Cancel debouncing things when unmounting
    react_1.useEffect(() => checkForLink.cancel(), []);
    react_1.useEffect(() => {
        checkForLink(text, (newDetection) => localDispatch({
            currentConversationId,
            detectedLink: newDetection,
            type: 'setDetectedLink',
        }));
    }, [currentConversationId, text]);
    react_1.useEffect(() => {
        localDispatch({
            currentConversationId,
            linkPreview: undefined,
            type: 'setLinkPreview',
        });
        if (!detectedLink) {
            return;
        }
        helpers_1.fetchLinkPreview(linkPreviewAPIUrl, detectedLink)
            .then((fetchedLinkPreview) => {
            if (fetchedLinkPreview) {
                localDispatch({
                    currentConversationId,
                    linkPreview: fetchedLinkPreview,
                    type: 'setLinkPreview',
                });
            }
        })
            .catch(() => localDispatch({
            currentConversationId,
            linkPreview: undefined,
            type: 'setLinkPreview',
        }));
    }, [currentConversationId, detectedLink, linkPreviewAPIUrl]);
    const disabled = !currentConversationId || (text.trim().length === 0 && images.length === 0);
    return (react_1.default.createElement(react_native_1.View, { style: [styles.container] },
        react_1.default.createElement(react_native_1.View, { style: {
                marginRight: 17,
            } }, me && react_1.default.createElement(Avatar_1.Avatar, { imageUri: me.imageUrl })),
        linkPreview ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => localDispatch({
                    currentConversationId,
                    linkPreview: undefined,
                    type: 'setLinkPreview',
                }), style: [
                    styles.linkPreviewButton,
                    { backgroundColor: theme.colors.surface },
                ] },
                react_1.default.createElement(react_native_1.View, { style: [
                        styles.linkPreviewWrapper,
                        { borderColor: theme.colors.border },
                    ] },
                    react_1.default.createElement(LinkPreview_1.LinkPreview, { linkPreview: linkPreview })),
                react_1.default.createElement(react_native_1.View, { style: styles.removeCircleWrapper },
                    react_1.default.createElement(RemoveCircle_1.RemoveCircle, { removeIcon: removeIcon }))))) : null,
        images.length > 0 && (react_1.default.createElement(react_native_1.View, { style: styles.imagesContainer }, images.map((imageUri) => (react_1.default.createElement(ImagePreview_1.ImagePreview, { key: imageUri, imageUri: imageUri, onRemove: () => {
                localDispatch({
                    currentConversationId,
                    images: images.filter((i) => i !== imageUri),
                    type: 'setImages',
                });
            }, removeIcon: removeIcon }))))),
        react_1.default.createElement(react_native_1.View, { style: styles.main },
            react_1.default.createElement(react_native_1.View, { style: [styles.inputContainer, { borderColor: theme.colors.border }] },
                react_1.default.createElement(TextInput_1.TextInput, { disabled: messengerDisabled, value: text, onChangeText: onChangeText, onSelectionChange: onSelectionChange, placeholder: placeholder, customStyles: {
                        color: theme.colors.sendButtonColor,
                        fontSize: 15,
                        fontWeight: '400',
                        paddingLeft: 18,
                        paddingVertical: 14,
                    } }),
                react_1.default.createElement(react_native_1.View, { style: styles.inputActions },
                    EmojiSelector ? (react_1.default.createElement(EmojiSelector, { onSelectEmoji: onSelectEmoji, disabled: messengerDisabled })) : null,
                    react_1.default.createElement(react_native_1.View, { style: {
                            marginLeft: 10,
                        } },
                        react_1.default.createElement(ImageUploadButton, { disabled: !currentConversationId || messengerDisabled, onImagesAdded: addImages },
                            react_1.default.createElement(react_native_1.View, null, cameraIcon))))),
            react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: sendMessage, disabled: disabled },
                react_1.default.createElement(react_native_1.View, { style: [
                        styles.sendButtonWrapper,
                        { backgroundColor: theme.colors.sendButtonColor },
                    ] }, sendIcon)))));
};
exports.MessageComposer = MessageComposer;
const styles = react_native_1.StyleSheet.create({
    container: {
        alignItems: 'center',
        flex: 1,
        flexDirection: 'row',
        minHeight: 86,
        padding: 20,
        paddingLeft: 15,
    },
    iconWrapper: {},
    imagesContainer: {
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    inputActions: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row',
        height: 52,
        marginRight: 14,
    },
    inputContainer: {
        alignItems: 'flex-end',
        borderRadius: 25,
        borderWidth: 1,
        flex: 1,
        flexDirection: 'row',
        marginRight: 10,
        minHeight: 50,
    },
    linkPreviewButton: {
        flex: 1,
        marginTop: 8,
    },
    linkPreviewWrapper: {
        borderRadius: 8,
        borderWidth: react_native_1.StyleSheet.hairlineWidth,
        flex: 1,
        overflow: 'hidden',
    },
    main: {
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        flexDirection: 'row',
        marginRight: 10,
    },
    removeCircleWrapper: {
        position: 'absolute',
        right: -10,
        top: -10,
    },
    sendButtonWrapper: {
        alignItems: 'center',
        borderRadius: 26,
        height: 52,
        justifyContent: 'center',
        width: 52,
    },
});
